export const DEFAULT_PAGINATOR_ROWS = 10;
export const DEFAULT_MEDIUM_PAGINATOR_ROWS = 20;
